import React from "react";
import { Layout } from "../../components/layout/Layout";
import { ModuleRouter } from "../../components/molecules/ModuleRouter";
import { HeadQuarterRoute } from "./head-quarter.routes";

export function Main() {
  return (
    <Layout>
      {HeadQuarterRoute.subRoutes && (
        <ModuleRouter subRoutes={HeadQuarterRoute.subRoutes} path={HeadQuarterRoute.path} />
      )}
    </Layout>
  );
}
